(function () {
  'use strict';

  angular
    .module('app.category.filters', ['rzModule'])

    .directive('filters', function () {
      return {
        restrict: 'E',
        scope: true,
        bindToController: {
          idCategory: '<',
          searchQuery: '@?',
          scroll: '<',
          titleBrand: '@',
          titleReview: '@',
          titleType: '@',
          device: '<',
          js: '@'
        },
        controllerAs: 'filtersCtrl',
        /* @ngInject */
        controller: ["LoadService", function (LoadService) {
          if (window.isBot || window.isCache) return;
          var ctrl = this;

          ctrl.$onInit = function () {
            LoadService.getService('AsyncCategoryService', { ctrl: ctrl }, 'initFilters');
          };
        }]
      };
    });
})();
